import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

interface OrgSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  debounceMs?: number;
}

export function OrgSearchBar({
  value,
  onChange,
  onSubmit,
  placeholder = "Buscar por nome, área ou função…",
  debounceMs = 200,
}: OrgSearchBarProps) {
  const [local, setLocal] = useState(value);

  useEffect(() => {
    setLocal(value);
  }, [value]);

  // Debounce: re-arm the timer only when the local input changes. Adding
  // `value` and `onChange` to deps would cancel the timer on every parent
  // render that recreates `onChange` — defeating the debounce.
  // biome-ignore lint/correctness/useExhaustiveDependencies: deps intentionally narrow to local/debounceMs
  useEffect(() => {
    const t = setTimeout(() => {
      if (local !== value) onChange(local);
    }, debounceMs);
    return () => clearTimeout(t);
  }, [local, debounceMs]);

  return (
    <div className="relative w-full max-w-md">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onChange(local);
            onSubmit?.();
          }
        }}
        placeholder={placeholder}
        className="pl-9 bg-card shadow-sm"
        data-testid="input-org-search"
      />
    </div>
  );
}
